module.exports = __webpack_public_path__ + "img/sd.c466d90e.svg";